export const name = 'nft';
